export const getEmptyForm = () => ({
  subject: 'HAS_CONTRACTS' as 'HAS_CONTRACTS' | 'NO_CONTRACTS',
  message: '',
});
